import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild} from '@angular/core';
import {Chart} from 'chart.js/auto';
import {EventiCounter} from '../../../_models/EventiCounter';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  standalone: false
})
export class BarChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() bars: EventiCounter[] = [];
  @Input() chartName: string = '';
  @Input() colors?: string[];
  @ViewChild('barCanvas') canvasRef?: ElementRef<HTMLCanvasElement>;
  public chart: Chart;
  private viewInitialized = false;

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.createChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.viewInitialized && changes['bars']) {
      setTimeout(() => this.createChart(), 0);
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  createChart() {
    if (!this.canvasRef) {
      return;
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    if (!this.bars || this.bars.length === 0) {
      return;
    }
    const labels: string[] = [];
    const datas: number[] = [];
    const starts: number[] = [];
    const dones: number[] = [];
    const sends: number[] = [];
    this.bars.forEach((bar: EventiCounter) => {
      labels.push(new Date(bar.day).toLocaleDateString());
      datas.push(bar.count);
      starts.push(bar.countStart);
      dones.push(bar.countDone);
      sends.push(bar.sendDone);
    });
    const defaultColors = ['blue', 'violet', 'green', 'gray'];
    const c = (i: number) => this.colors?.[i] ?? defaultColors[i];
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.chart = new Chart(this.canvasRef.nativeElement, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'Eventi', data: datas, backgroundColor: c(0),
            borderRadius: Number.MAX_VALUE, borderSkipped: false
          },
          {
            label: 'Ordini lanciati', data: starts, backgroundColor: c(1),
            borderRadius: Number.MAX_VALUE, borderSkipped: false
          },
          {
            label: 'Ordini terminati', data: dones, backgroundColor: c(2),
            borderRadius: Number.MAX_VALUE, borderSkipped: false
          },
          {
            label: 'Ordini inviati', data: sends, backgroundColor: c(3),
            borderRadius: Number.MAX_VALUE, borderSkipped: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: isMobile ? 'bottom' : 'top',
            labels: {
              boxWidth: isMobile ? 14 : 20,
              boxHeight: isMobile ? 10 : 12,
              padding: isMobile ? 8 : 12,
              font: {
                size: isMobile ? 10 : 12
              }
            }
          }
        },
        scales: {
          x: {
            ticks: {
              autoSkip: true,
              maxTicksLimit: isMobile ? 6 : 12,
              maxRotation: isMobile ? 45 : 0,
              minRotation: isMobile ? 45 : 0,
              font: {
                size: isMobile ? 10 : 11
              }
            }
          },
          y: {
            ticks: {
              precision: 0,
              font: {
                size: isMobile ? 10 : 11
              }
            }
          }
        }
      }
    });
  }
}
